import {
  EarningsInsightRecapResponse,
  EarningsInsightRecapV4Response,
  earningsInsights,
} from '@api';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';
import {
  createEarningsInsightQueryOptions,
  useEarningsInsightQueries,
} from './useEarningsInsightQueries';

export const QUERY_KEY_EARNINGS_INSIGHT_RECAP =
  'QUERY_KEY_EARNINGS_INSIGHT_RECAP';
export const QUERY_KEY_EARNINGS_INSIGHT_RECAP_V4 =
  'QUERY_KEY_EARNINGS_INSIGHT_RECAP_V4';

const fetchEarningsInsightRecap = (
  earningsInsightId: string,
  signal?: AbortSignal
) => {
  const { path, schema } = earningsInsights.getEarningsInsightRecap;
  return wretchRequest<EarningsInsightRecapResponse>(path(earningsInsightId), {
    method: 'get',
    schema,
    signal,
  });
};

const fetchEarningsInsightRecapV4 = (
  earningsInsightId: string,
  signal?: AbortSignal
) => {
  const { path, schema } = earningsInsights.getEarningsInsightRecapV4;
  return wretchRequest<EarningsInsightRecapV4Response>(
    path(earningsInsightId),
    {
      method: 'get',
      schema,
      signal,
    }
  );
};

export const useGetEarningsInsightRecap = (earningsInsightId: string) =>
  useQuery(
    createEarningsInsightQueryOptions({
      earningsInsightId,
      queryKey: QUERY_KEY_EARNINGS_INSIGHT_RECAP,
      queryFn: fetchEarningsInsightRecap,
      enabled: !!earningsInsightId,
    })
  );

export const useEarningsInsightRecaps = (earningsInsightIds: string[]) =>
  useEarningsInsightQueries({
    earningsInsightIds,
    queryKey: QUERY_KEY_EARNINGS_INSIGHT_RECAP,
    queryFn: fetchEarningsInsightRecap,
  });

export const useEarningsInsightRecapsV4 = (earningsInsightIds: string[]) =>
  useEarningsInsightQueries({
    earningsInsightIds,
    queryKey: QUERY_KEY_EARNINGS_INSIGHT_RECAP_V4,
    queryFn: fetchEarningsInsightRecapV4,
  });
